<template>
  <div
    ref="ConferecneDoctor"
    v-if="!isfinishConference"
    class="conference-wrapper d-flex align-center justify-center"
    style="position: relative"
  >
    <div v-if="isFlashing" class="flash-overlay"></div>
    <div
      class="full-screen-card"
      style="background-color: black; overflow: auto; overflow-x: hidden"
    >
      <div class="mb-0 pt-6">
        <!-- <div class="my-2 ml-4">
            <v-btn
              color="secondary"
              fab
              dark
            >
               <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </div> -->
        <v-row class="my-0 pa-0 ma-0 pt-4">
          <v-col
            cols="12"
            :style="
              isCheckPrticipant
                ? 'position: relative; z-index: 2; top: 15vh; right: 3vw'
                : ''
            "
            :class="
              !isCheckPrticipant
                ? 'd-flex align-center justify-center d-flex flex-column pt-6 mb-0'
                : 'd-flex align-end justify-end d-flex flex-column pt-0'
            "
          >
            <video
              v-show="isCheckVideo && isCameraOff"
              :width="!isCheckPrticipant ? '100%' : '200px'"
              height="auto"
              ref="localVideoElement"
              autoplay
              playsinline
              :style="
                !isCheckPrticipant
                  ? 'border-radius: 10px; background-color:#262626;height: 80vh;'
                  : 'border-radius: 10px; border: 2px solid'
              "
            ></video>
            <div
              v-if="isCameraOff && ischeckParticipantConnect"
              class="mb-2 pt-1"
            >
              <v-btn
                small
                dark
                style="
                  width: auto;
                  background-color: rgba(0, 0, 0, 0.5);
                  border-radius: 8px;
                "
              >
                <v-icon size="18" v-if="!isMuted" style="color: red"
                  >mdi-microphone-off</v-icon
                ><span class="text-white no-uppercase">{{
                  this.senderName
                }}</span>
              </v-btn>
            </div>
            <v-card
              v-if="isCheckVideo && !isCameraOff"
              :width="!isCheckPrticipant ? '100%' : '200px'"
              :height="!isCheckPrticipant ? '85vh' : '115px'"
              style="border-radius: 10px; background-color: #313232"
              class="d-flex justify-center align-center position-relative"
              ><v-container fluid class="d-flex justify-center">
                <v-icon
                  :size="!isCheckPrticipant ? '600' : '100'"
                  style="color: #575959"
                  >mdi-account</v-icon
                >
                <v-icon
                  :size="!isCheckPrticipant ? '30' : '20'"
                  color="red"
                  style="
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    cursor: pointer;
                  "
                >
                  mdi-camera-off-outline
                </v-icon>
              </v-container></v-card
            >
            <div
              v-if="!isCameraOff && ischeckParticipantConnect"
              class="mb-2 pt-1"
            >
              <v-btn
                small
                dark
                style="
                  width: auto;
                  background-color: rgba(0, 0, 0, 0.5);
                  border-radius: 8px;
                "
              >
                <v-icon size="18" v-if="!isMuted" style="color: red"
                  >mdi-microphone-off</v-icon
                ><span class="text-white no-uppercase">{{
                  this.senderName
                }}</span>
              </v-btn>
            </div>
          </v-col>
          <v-col
            v-if="ischeckParticipantConnect"
            cols="12"
            style="position: absolute; top: 100px; left: 0; z-index: 1"
            class="d-flex justify-center pt-1"
          >
            <v-row
              class="d-flex justify-center"
              style="background-color: #262626; height: 70vh"
            >
              <div
                v-if="!isCameraParticipant"
                ref="remoteVideoContainer"
                class="pt-0"
                :style="
                  isOpenDisplay
                    ? 'border-radius: 10px; background-color:#262626 ;width: auto; height: 70vh; overflow: hidden;'
                    : 'border-radius: 10px;'
                "
              ></div>
              <div v-else>
                <v-card
                  width="60vw"
                  height="100%"
                  class="d-flex justify-center align-center position-relative"
                  style="border-radius: 10px; background-color: #313232"
                >
                  <v-icon size="130" style="color: #575959">mdi-account</v-icon>
                  <v-icon
                    size="30"
                    color="red"
                    style="
                      position: absolute;
                      top: 10px;
                      left: 10px;
                      cursor: pointer;
                    "
                  >
                    mdi-camera-off-outline
                  </v-icon>
                </v-card>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div class="pt-2">
        <img :src="screenshot" alt="Video Screenshot" class="screenshot-img" />
      </div>
    </div>
    <div
      v-if="room"
      class="pt-4"
      style="
        z-index: 3;
        position: absolute;
        bottom: 0;
        left: 0;
        top: 88%;
        width: 100%;
      "
    >
      <div class="mb-0 pb-0 mb-6 pt-6 d-flex align-center justify-center">
        <v-btn
          v-if="room"
          @click="toggleMicrophone"
          class="ml-4 mx-4"
          dark
          color="#3c3d3e"
          fab
          small
        >
          <v-icon>{{
            isMuted ? "mdi-microphone" : "mdi-microphone-off"
          }}</v-icon>
        </v-btn>
        <v-btn
          v-if="room"
          @click="toggleCamera"
          class="mr-4"
          dark
          color="#3c3d3e"
          fab
          small
        >
          <v-icon>{{
            isCameraOff
              ? "mdi mdi-camera-outline"
              : "mdi mdi-camera-off-outline"
          }}</v-icon>
        </v-btn>

        <!-- <v-btn
          v-if="room"
          @click="captureScreen()"
          class="mr-4"
          dark
          fab
          color="#3c3d3e"
        
        >
          <v-icon>mdi-monitor-screenshot</v-icon>
        </v-btn> -->
        <v-btn
          v-if="room"
          @click="recordVideo()"
          class="mr-4"
          dark
          color="#3c3d3e"
          fab
          small
        >
          <v-icon>{{
            isRecord ? "mdi-video-check-outline" : "mdi-video-outline"
          }}</v-icon>
        </v-btn>

        <v-btn @click="leaveRoom" color="red" dark fab small>
          <v-icon>mdi mdi-phone-return-outline</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
  <div v-else class="d-flex align-center justify-center fill-height bg-color">
    <v-container
      class="d-flex flex-column justify-center align-center fill-height"
      fluid
    >
      <div
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <span class="text-00A99D w-500 text font"
          >สิ้นสุดการสนทนา ขอบคุณครับ</span
        >
      </div>
      <v-img
        :src="require('@/assets/icon/Telepharma/Doctor.svg')"
        style="
          position: absolute;
          bottom: 0px;
          left: 0;
          width: 100%;
          max-width: 300px;
          height: auto;
        "
      />
      <v-img
        :src="require('@/assets/icon/Telepharma/BG.svg')"
        style="
          position: absolute;
          bottom: 0;
          right: 0;
          width: 100%;
          max-width: 300px;
          height: auto;
        "
      />
    </v-container>
  </div>
</template>

<script>
import { Room, createLocalTracks } from "livekit-client";
import buttonSfx from "@/assets/sounds/ring-call.mp3";
var myTrack = new Audio(buttonSfx);
import Swal from "sweetalert2";
import { EventBus } from "../../EventBus";
import html2canvas from "html2canvas";
export default {
  props: {
    item: String,
    back: Boolean,
    sender: Boolean,
  },
  data() {
    return {
      room: null,
      roomName: "",
      myTrack,
      localTracks: [],
      localAudioTrack: null,
      isMuted: true,
      isCheckVideo: false,
      prticipantName: "",
      senderName: "",
      isCheckPrticipant: false,
      isRinging: false,
      ringInterval: null,
      isCameraOff: true,
      token: this.$route.query.token,
      accessToken: this.$route.query.access_token,
      isCameraParticipant: false,
      lastVideoTrack: null,
      participantRef: null,
      deviceType: "",
      participantsMicrophone: "on",
      isfinishConference: false,
      isOpenDisplay: false,
      screenshot: "",
      ischeckParticipantConnect: false,
      isRecord: false,
      isCheckConnect: true,
      isFlashing: false,
    };
  },
  watch: {
    isCheckPrticipant(newVal) {
      this.isCheckPrticipant = newVal;
      if (newVal && this.room && this.room.participants) {
        this.room.participants.forEach((participant) => {
          participant.tracks.forEach((publication) => {
            if (publication.track) {
              this.createParticipantVideo(publication.track);
            }
          });
        });
      }
    },
    isCameraParticipant(newVal) {
      if (!newVal && this.lastVideoTrack && this.participantRef) {
        this.$nextTick(() => {
          this.createParticipantVideo(this.lastVideoTrack, this.participantRef);
        });
      }
    },
    // participantsMicrophone(newVal) {
    //   if (newVal && this.lastVideoTrack && this.participantRef) {
    //     this.$nextTick(() => {
    //       const container = this.$refs.remoteVideoContainer;
    //       while (container.firstChild) {
    //         container.removeChild(container.firstChild);
    //       }
    //       this.createParticipantVideo(this.lastVideoTrack, this.participantRef);
    //     });
    //   }
    // },
    back(newVal) {
      if (newVal == true) {
        this.leaveRoom();
      }
    },
  },
  created() {
    this.token = this.item;
    if (!this.token || this.token == "") {
      this.token = this.$route.query.token;
    }
    this.isfinishConference = false;
    this.createRoom();
  },
  methods: {
    async createRoom() {
      try {
        this.isCheckVideo = true;
        const url = process.env.VUE_APP_ONE_CONFERENCE;
        const token = this.token || this.item;
        const roomOptions = {
          audioCaptureDefaults: {
            echoCancellation: true,
            noiseSuppression: "enhanced",
            autoGainControl: true,
          },
        };
        this.room = new Room();
        await this.room.connect(url, token, roomOptions);
        this.senderName = this.room.localParticipant.identity;
        this.roomName = this.room.roomInfo.name;
        await this.checkPermissions();
        if (
          this.room &&
          this.room.sidToIdentity &&
          this.room.sidToIdentity.size == 0
        ) {
          this.isRinging = true;
          await this.incomingCall();
        }
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some(
          (device) => device.kind === "videoinput"
        );
        try {
          // พยายามสร้างทั้ง audio + video track
          this.localTracks = await createLocalTracks({
            audio: {
              echoCancellation: true,
              noiseSuppression: true,
              autoGainControl: true,
            },
            video: hasVideoInput,
          });
        } catch (err) {
          // fallback เป็น audio-only
          this.localTracks = await createLocalTracks({
            audio: {
              echoCancellation: true,
              noiseSuppression: true,
              autoGainControl: true,
            },
            video: false,
          });
          this.isCameraOff = false;
        }
        // ค้นหาแทร็กเสียงและเปิดใช้งาน
        this.localAudioTrack = this.localTracks.find((t) => t.kind === "audio");
        if (this.localAudioTrack) {
          await this.room.localParticipant.publishTrack(this.localAudioTrack);
          if (this.localAudioTrack.isMuted) {
            await this.localAudioTrack.unmute();
          }
        }

        this.localVideoTrack = this.localTracks.find((t) => t.kind === "video");
        if (this.localVideoTrack) {
          this.localVideoTrack.attach(this.$refs.localVideoElement);
          await this.room.localParticipant.publishTrack(this.localVideoTrack);
        }

        // แสดงวิดีโอตัวเอง
        const videoTrack = this.localTracks.find((t) => t.kind === "video");
        if (videoTrack) {
          videoTrack.attach(this.$refs.localVideoElement);
          await this.room.localParticipant.publishTrack(videoTrack);
          this.isCheckConnect = false;
        }
        // ดึงวิดีโอของผู้เข้าร่วมที่เข้ามาใหม่
        this.room.on("participantConnected", (participant) => {
          this.ischeckParticipantConnect = true;
          this.deviceType = "mobile";
          this.isRinging = false;
          this.stopRinging();
          this.prticipantName = participant.identity;
          this.isCheckPrticipant = true;
          this.setParticipantAudio(participant);
          this.recordVideo();
        });
        // ดึงวิดีโอของผู้เข้าร่วมที่อยู่ในห้องอยู่แล้ว
        const previousParticipants = Array.from(
          this.room.remoteParticipants.values()
        );
        if (previousParticipants.length > 0) {
          this.ischeckParticipantConnect = true;
          this.isRinging = false;
          this.stopRinging();
          this.deviceType = "desktop";
          this.prticipantName = previousParticipants[0].identity;
          this.setParticipantAudio(previousParticipants[0]);
          this.isCheckPrticipant = true;
          // this.recordVideo();
        }
        // ออกจากห้อง หรือ วางสายหลังจากที่ผู้เข้าร่วมออกจากห้อง
        this.room.on("participantDisconnected", async (participant) => {
          if (participant) {
            let message = `${participant.identity} ออกจากห้อง`;
            this.ischeckParticipantConnect = false;
            this.isCheckPrticipant = false;
            this.showMessagesAlert("info", message);
            await this.leaveRoom();
            const ending = true
            this.$emit("data-ending-conference", ending); 
          }
          await this.leaveRoom();
        });
      } catch (error) {
        console.error(error);
      }
    },
    setParticipantAudio(participant) {
      try {
        // ตรวจสอบว่า participant มี trackPublications หรือไม่
        if (!participant || !participant.trackPublications) {
          return;
        }
        // ฟัง event เมื่อมี track ใหม่ถูกเผยแพร่
        participant.on("trackPublished", async (publication) => {
          const track = await publication.track;
          if (track) {
            this.createParticipantVideo(track, participant);
          }
          publication.on("subscribed", (track) => {
            if (track) {
              // ตรวจสอบว่ากล้องเปิดหรือปิด
              if (track.kind === "video") {
                if (track.isMuted) {
                  this.isCameraParticipant = true;
                } else {
                  this.isCameraParticipant = false;
                }
                this.createParticipantVideo(track, participant);
                // ฟัง event เปิด/ปิดกล้อง
                track.on("muted", () => {
                  this.isCameraParticipant = true;
                });

                track.on("unmuted", () => {
                  this.isCameraParticipant = false;
                });
              }

              // ตรวจสอบว่าไมค์เปิดหรือปิด
              if (track.kind === "audio") {
                const audioElement = track.attach();
                audioElement.autoplay = true;
                audioElement.style.display = "none";
                document.body.appendChild(audioElement);
                // ฟัง event ปิดไมค์
                track.on("muted", () => {
                  this.participantsMicrophone = "off";
                });

                // ฟัง event เปิดไมค์
                track.on("unmuted", () => {
                  this.participantsMicrophone = "on";
                });
              }
            }
          });
        });

        // วน loop ตรวจสอบ track ที่มีอยู่แล้ว
        participant.trackPublications.forEach((publication) => {
          if (publication.track) {
            this.createParticipantVideo(publication.track, participant);
          }

          publication.on("subscribed", (track) => {
            if (track) {
              this.createParticipantVideo(track, participant);
            }
          });

          if (publication.kind === "video") {
            // ตรวจสอบว่ากล้องเปิดหรือปิด
            if (publication.track.isMuted) {
              this.isCameraParticipant = true;
            } else {
              this.isCameraParticipant = false;
            }
            publication.track.on("muted", () => {
              this.isCameraParticipant = true;
            });

            publication.track.on("unmuted", () => {
              this.isCameraParticipant = false;
            });
          }
          // ตรวจสอบว่าไมค์เปิดหรือปิด
          if (publication.kind === "audio") {
            const audioElement = publication.track.attach();
            audioElement.autoplay = true;
            audioElement.style.display = "none";
            document.body.appendChild(audioElement);
            // ฟัง event ปิดไมค์
            publication.on("muted", () => {
              this.participantsMicrophone = "off";
            });
            // ฟัง event เปิดไมค์
            publication.on("unmuted", () => {
              this.participantsMicrophone = "on";
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    createParticipantVideo(track, participant) {
      try {
        if (track.kind === "video") {
          let videoElement = document.getElementById(
            `video-${participant.identity}`
          );
          if (!videoElement) {
            this.isOpenDisplay = true;
            videoElement = document.createElement("video");
            videoElement.id = `video-${participant.identity}`;
            videoElement.style.width = "100%";
            videoElement.style.height = "100%";
            videoElement.autoplay = true;
            videoElement.playsInline = true;
            videoElement.style.borderRadius = "10px";
            videoElement.style.objectFit = "cover";

            this.$nextTick(() => {
              if (this.$refs.remoteVideoContainer) {
                const wrapper = document.createElement("div");
                wrapper.style.position = "relative";
                wrapper.style.width = "100%";
                wrapper.style.height = "100%";
                wrapper.style.borderRadius = "10px";
                wrapper.style.overflow = "hidden";

                wrapper.appendChild(videoElement);
                const nameLabel = document.createElement("div");
                nameLabel.textContent = participant.identity || "Guest";
                nameLabel.style.position = "absolute";
                nameLabel.style.bottom = "8px";
                nameLabel.style.left = "10px";
                nameLabel.style.color = "white";
                nameLabel.style.background = "rgba(0, 0, 0, 0.5)";
                nameLabel.style.padding = "3px 8px";
                nameLabel.style.borderRadius = "6px";
                nameLabel.style.fontSize = "14px";
                nameLabel.style.fontWeight = "500";
                nameLabel.style.pointerEvents = "none";

                wrapper.appendChild(nameLabel);
                this.$refs.remoteVideoContainer.appendChild(wrapper);
                track.attach(videoElement);
              }
            });
          } else {
            this.isOpenDisplay = true;
            const existingVideo = document.getElementById(
              `video-${participant.identity}`
            );
            if (existingVideo) {
              existingVideo.remove();
            }
            videoElement = document.createElement("video");
            videoElement.id = `video-${participant.identity}`;
            videoElement.style.width = "100%";
            videoElement.style.height = "100%";
            videoElement.autoplay = true;
            videoElement.playsInline = true;
            videoElement.style.borderRadius = "10px";
            videoElement.style.objectFit = "cover";

            this.$nextTick(() => {
              if (this.$refs.remoteVideoContainer) {
                const wrapper = document.createElement("div");
                wrapper.style.position = "relative";
                wrapper.style.width = "100%";
                wrapper.style.height = "100%";
                wrapper.style.borderRadius = "10px";
                wrapper.style.overflow = "hidden";
                wrapper.appendChild(videoElement);
                const nameLabel = document.createElement("div");
                nameLabel.textContent = participant.identity || "Guest";
                nameLabel.style.position = "absolute";
                nameLabel.style.bottom = "8px";
                nameLabel.style.left = "10px";
                nameLabel.style.color = "white";
                nameLabel.style.background = "rgba(0, 0, 0, 0.5)";
                nameLabel.style.padding = "3px 8px";
                nameLabel.style.borderRadius = "6px";
                nameLabel.style.fontSize = "14px";
                nameLabel.style.fontWeight = "500";
                nameLabel.style.pointerEvents = "none";

                wrapper.appendChild(nameLabel);
                this.$refs.remoteVideoContainer.appendChild(wrapper);
                track.attach(videoElement);
              }
            });
          }
          (this.lastVideoTrack = track), (this.participantRef = participant);
        }
      } catch (err) {
        console.log(err);
      }
    },
    toggleMicrophone() {
      try {
        if (this.localAudioTrack) {
          this.isMuted = !this.isMuted;
          if (this.isMuted) {
            this.localAudioTrack.unmute();
          } else {
            this.localAudioTrack.mute();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    toggleCamera() {
      try {
        if (this.localVideoTrack) {
          this.isCameraOff = !this.isCameraOff;
          if (this.isCameraOff) {
            this.localVideoTrack.unmute();
          } else {
            this.localVideoTrack.mute();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    leaveRoom() {
      try {
        this.isCheckVideo = false;
        this.stopRinging();
        // this.$router.push("/finish-conference");
        this.isfinishConference = true;
        localStorage.removeItem("token");
        if (this.room) {
          this.localTracks.forEach((track) => track.stop());
          this.room.disconnect();
          this.room = null;
          if (this.$refs.localVideoElement) {
            this.$refs.localVideoElement.srcObject = null;
          }
          if (this.$refs.remoteVideoContainer) {
            this.$refs.remoteVideoContainer.innerHTML = null;
          }
          this.isCheckVideo = false;
          this.isCheckPrticipant = false;
          this.isMuted = true;
          this.isCameraOff = true;
          this.localAudioTrack.mute();
          this.localVideoTrack.mute();
          // this.$router.push("/finish-conference");
          this.isfinishConference = true;
          this.stopRinging();
          if (this.sender) {
            this.conferencesHangUp();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    incomingCall() {
      if (this.isRinging) {
        this.myTrack.play();
        this.ringInterval = setInterval(() => {
          this.myTrack.play();
        }, this.myTrack.duration * 3000);
      }
    },
    stopRinging() {
      this.isRinging = false;
      clearInterval(this.ringInterval);
      this.myTrack.pause();
      this.myTrack.currentTime = 0;
    },
    async captureScreen() {
      await this.flashAnimation();
      const element = this.$refs.ConferecneDoctor;
      const canvas = await html2canvas(element, { useCORS: true });
      this.screenshot = await new Promise((resolve) => {
        canvas.toBlob((blob) => {
          resolve(blob);
        }, "image/png");
      });
      if (this.screenshot) {
        this.createImage();
      }
    },
    async createImage() {
      this.showMessagesAlert("success", "จับภาพหน้าจอเรียบร้อยแล้ว");
      // Swal.fire({
      //   toast: true,
      //   html: `<div style='display: flex; align-items: center;'><img src='${require("@/assets/icon/weather_Y.png")}' alt='Icon' style='max-width: 50%; max-height: 50px; margin-bottom: 0px; margin-left: 10px;'> <span style='margin-left: 10px;font-size: 16px;font-family: Sarabun;font-weight: 500; color: white;' > เหลือเวลา Conference อีก 5 นาที</span> </div>`,
      //   animation: false,
      //   height: "20px",
      //   width: "430px",
      //   position: "bottom",
      //   showConfirmButton: false,
      //   timer: 3000,
      //   timerProgressBar: true,
      //   borderRadius:"10px",
      //   background: "green",
      //   didOpen: (toast) => {
      //     toast.addEventListener("mouseenter", Swal.stopTimer);
      //     toast.addEventListener("mouseleave", Swal.resumeTimer);
      //   },
      // });
      // try {
      //   const formData = new FormData();
      //   formData.append("room_name", this.roomName);
      //   formData.append("access_token", this.accessToken);
      //   formData.append("file", this.screenshot, "screenshot.png");
      //   await this.axios
      //     .post(
      //       `${process.env.VUE_APP_BASE_URL}/telemed/public/prt-scr-conference`,
      //       formData
      //     )
      //     .then((res) => {
      //       if (
      //         res.status === 200 &&
      //         res.data.message === "save image prt scr success"
      //       ) {
      //         this.showMessagesAlert("success", "จับภาพหน้าจอเรียบร้อยแล้ว");
      //       }
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       this.showMessagesAlert("error", "ไม่สามารถจับภาพหน้าจอได้");
      //     });
      // } catch (err) {
      //   console.log(err);
      // }
    },
    showMessagesAlert(icon, message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        iconColor: "white",
        width: "430px",
        customClass: {
          popup: "colored-toast",
        },
        showConfirmButton: false,
        timer: 1800,
        timerProgressBar: true,
      });
      if (message == "จับภาพหน้าจอเรียบร้อยแล้ว") {
        return Toast.fire({
          icon: icon,
          html: `
      <div style="display: flex; align-items: center; gap: 12px;">
        <img src="${this.screenshot}" alt="icon" style="width: 70px; height: 50px;" />
        <span style="color: white; font-size: 16px; font-family: Sarabun; font-weight: 500;">
          ${message}
        </span>
      </div>
    `,
        });
      } else {
        return Toast.fire({
          icon: icon,
          html: `
          <div>
            <span style="color: white; font-size: 16px; font-family: Sarabun; font-weight: 500;">
              ${message}
            </span>
          </div>
        `,
        });
      }
    },
    async recordVideo() {
      this.isRecord = true;
      try {
        let body = {
          room_name: this.roomName,
        };
        console.log("🚀 ~ body:", body)
        this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v1/test/conference/record`, body)
          .then((res) => {
            if (res.status === 200) {
              this.showMessagesAlert("info", "กำลังบันทึกวิดีโอ");
            }
          })
          .catch((error) => {
            console.log(error);
            this.showMessagesAlert("error", "ไม่สามารถบันทึกวิดีโอได้");
          });
      } catch (err) {
        this.showMessagesAlert("error", "ไม่สามารถบันทึกวิดีโอได้");
        console.lof(err);
      }
    },

    async checkPermissions() {
      try {
        const cameraPerm = await navigator.permissions.query({
          name: "camera",
        });
        const micPerm = await navigator.permissions.query({
          name: "microphone",
        });

        if (cameraPerm.state === "granted" && micPerm.state === "granted") {
          console.log("กล้องและไมค์ถูกอนุญาตไว้แล้ว");
          return;
        }

        // ถ้า permission ไม่ใช่ granted ให้เรียกเพื่อขอ
        await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        console.log("ขออนุญาตกล้องและไมค์แล้ว");
      } catch (err) {
        console.error("ไม่สามารถเข้าถึงกล้องหรือไมค์ได้:", err);
        throw err;
      }
    },

    async flashAnimation() {
      this.isFlashing = true;
      await new Promise((resolve) => setTimeout(resolve, 320));
      this.isFlashing = false;
      await this.$nextTick();
      const element = this.$refs.ConferecneDoctor;
      console.log("🚀 ~ captureScreen ~ element:", element);
      if (element) {
        const canvas = await html2canvas(element, { useCORS: true });
        this.screenshot = canvas.toDataURL("image/png");
      }
      this.showMessagesAlert("success", "จับภาพหน้าจอเรียบร้อยแล้ว");
    },

    async conferencesHangUp() {
      try {
        let params = new URLSearchParams();
        params.append("his_id", this.roomName);
        this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/conferences/hang_up`, {
            params: params,
          })
          .then((res) => {
            console.log("conferences success", res);
            EventBus.$emit("endingSuccess");
          });
      } catch (error) {
        console.log("error", error.message);
      }
    },
  },
};
</script>

<style scoped>
.fill-height {
  height: 100%;
}
.button-container {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #ffffff;
}

.full-screen-card {
  width: 100vw;
  height: 100vh;
}

.conference-wrapper {
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.flash-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  opacity: 0.8;
  animation: flash 0.3s ease-in-out;
  z-index: 9999;
}
@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.text {
  background-size: contain;
  z-index: 100;
}
@media only screen and (max-width: 500px) {
  .font {
    font-size: 18px;
  }
}
@media only screen and (min-width: 750px) {
  .font {
    font-size: 25px;
  }
}
@media only screen and (min-width: 951px) {
  .font {
    font-size: 32px;
  }
}
.bg-color {
  background-color: #ebf7f7 !important;
  height: 100%;
}
.v-btn .no-uppercase {
  text-transform: none !important;
}
</style>
